import script from "./CompanyServiceCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyServiceCreateView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyServiceCreateView.vue?vue&type=style&index=0&id=0b2ea509&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2ea509"]])

export default __exports__